import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconInfoSquare: React.FC<IconProps> = ({ ...props }) => {
  return (
    <Icon {...props}>
      <path
        opacity="0.4"
        d="M13.6167 1.6665H6.39167C3.56667 1.6665 1.66667 3.64984 1.66667 6.59984V13.4082C1.66667 16.3498 3.56667 18.3332 6.39167 18.3332H13.6167C16.4417 18.3332 18.3333 16.3498 18.3333 13.4082V6.59984C18.3333 3.64984 16.4417 1.6665 13.6167 1.6665Z"
        fill="#200E32"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.27059 6.82438C9.27059 7.22605 9.59642 7.55355 9.99559 7.55355C10.4064 7.55355 10.7331 7.22605 10.7331 6.82438C10.7331 6.42271 10.4064 6.09521 10.0039 6.09521C9.59975 6.09521 9.27059 6.42271 9.27059 6.82438ZM10.7248 9.46838C10.7248 9.06671 10.3973 8.73921 9.99559 8.73921C9.59392 8.73921 9.26642 9.06671 9.26642 9.46838V13.1517C9.26642 13.5534 9.59392 13.8809 9.99559 13.8809C10.3973 13.8809 10.7248 13.5534 10.7248 13.1517V9.46838Z"
        fill="#200E32"
      />
    </Icon>
  );
};

export default IconInfoSquare;
